import React, { useMemo } from "react";
import Select from "react-select";
import styled from "styled-components";
import userDefaultImage from "../../images/default-profile.png";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";

const ValuesContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const SelectPS = (props) => {
  const {
    users,
    options = [],
    returnSuccess,
    returnError,
    loading,
    setShowAddPS,
    showAddPS,
    value,
    onChange,
    ...selectRest
  } = props;
  const databaseLink = "https://images.expertpowerhouse.com";

  const dropdownOptions = useMemo(() => {
    if (!options?.length) return options ?? [];
    if (!users?.length) return options;
    const activeEmails = new Set(
      users.filter((u) => u.isActive === "yes").map((u) => u.email)
    );
    const filtered = options.filter((opt) => activeEmails.has(opt.value));
    if (!value?.length) return filtered;
    const inFiltered = new Set(filtered.map((o) => o.value));
    const extra = value.filter((v) => !inFiltered.has(v.value));
    return extra.length ? [...filtered, ...extra] : filtered;
  }, [options, users, value]);

  const handleRemoveValue = (e) => {
    if (!onChange) return;
    const buttonName = e.currentTarget.getAttribute("name");
    const removedValue = value.find((val) => val.value === buttonName);
    if (!removedValue) return;
    onChange(
      value.filter((val) => val.value !== buttonName),
      { name: buttonName, action: "remove-value", removedValue }
    );
  };

  return (
    <div>
      <ValuesContainer>
        {value
          ? value.map((val) => (
              <div key={val.value} className="po-single-prjsupporter-div">
                {users.map((user) => {
                  if (user.email === val.value) {
                    return (
                      <>
                        <img
                          src={
                            user.profilePicture?.includes("data:image")
                              ? user.profilePicture
                              : user.profilePicture !== ""
                              ? `${databaseLink}${user.profilePicture}`
                              : userDefaultImage
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = userDefaultImage;
                          }}
                          // src={
                          //   user.profilePicture
                          //     ? user.profilePicture
                          //     : userDefaultImage
                          // }
                          width={24}
                          height={24}
                          alt="user"
                          className="rounded-circle"
                          title={user.username}
                          style={{ height: "24px", width: "24px" }}
                        />
                        <i
                          className="fa-solid fa-circle-xmark"
                          name={val.value}
                          onClick={handleRemoveValue}
                        ></i>
                      </>
                    );
                  }
                })}
              </div>
            ))
          : null}

        <i
          className="fa-solid fa-circle-plus add-prjsupporter-icon"
          title="Add project supporter"
          onClick={() => setShowAddPS(!showAddPS)}
        ></i>
        {showAddPS && (
          <Select
            {...selectRest}
            value={value}
            onChange={onChange}
            options={dropdownOptions}
            controlShouldRenderValue={false}
            closeMenuOnSelect={true}
            menuPosition="fixed"
          />
        )}
      </ValuesContainer>
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", right: "-16px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}

      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", right: "-16px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", right: "-16px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </div>
  );
};

export default SelectPS;
